import * as types from "../actions/index";
export default function(state = null, action) {
  switch (action.type) {
    case types.SET_FORM_UPDATED:
      return action.payload;
    // no default
  }
  return state;
}
